import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="keyboard-shortcuts"
export default class extends Controller {
  static targets = ['tooltip']

  connect () {
    let fullScreenContainer = document.querySelector("[data-controller~='mct']")
    fullScreenContainer ??= document.body
    this.tooltip = document.createElement('div')
    this.tooltip.classList.add('tooltip')
    fullScreenContainer.appendChild(this.tooltip)
    this.onMouseMove = this.onMouseMove.bind(this)
  }

  disconnect () {
    this.tooltip.remove()
  }

  tooltipTargetConnected (target) {
    target.addEventListener('mousemove', this.onMouseMove)
  }

  tooltipTargetDisconnected (target) {
    target.removeEventListener('mousemove', this.onMouseMove)
  }

  onMouseMove (event) {
    const offset = 20
    const left = event.clientX
    const top = event.clientY + offset
    this.tooltip = document.querySelector('.tooltip')
    this.tooltip.textContent = event.currentTarget.dataset.tooltipText
    const tooltipRect = this.tooltip.getBoundingClientRect()

    // const wouldOverflowRight = left + tooltipRect.width > window.innerWidth
    // const wouldOverflowBottom = top + tooltipRect.height > window.innerHeight
    this.tooltip.style.left = `${Math.min(left, window.innerWidth - tooltipRect.width)}px`
    this.tooltip.style.top = `${Math.min(top, window.innerHeight - tooltipRect.height)}px`
  }
}
